import type { FC } from 'react';
import { useCallback } from 'react';

import Button from '@trend-dev/trendtech-ui/components/UI/Button';
import { Icon } from '@trend-dev/ui-libs-icons';

import { useSizeStore } from 'store/size';

import { useAllUserList } from 'hooks/useAllUserList';

import { useFullScreenApi } from './hooks/useFullScreenApi';
import styles from './styles.module.scss';

const SizeControl: FC = () => {
    const { isFull, setIsFull } = useSizeStore();
    const { screenShareUser } = useAllUserList();

    useFullScreenApi();
    // Показываем кнопку "Во весь экран" только если кто-то демонстрирует экран
    const showControl = !!screenShareUser;

    const toggleSize = useCallback(() => {
        setIsFull(prevState => !prevState);
    }, []);

    if (!showControl) return null;

    return (
        <Button className={styles.wrapper} borderRadius='full' onlyIcon insideIndent={3} size='lg' onClick={toggleSize} kind='gray'>
            <Icon name={isFull ? 'Minimize_20' : 'arrows-pointing-out-diagonal-line-medium-20'} />
        </Button>
    );
};

export default SizeControl;
